import { useState } from 'react';
import { X, Info } from 'lucide-react';
import { useTranslation } from '@/hooks/useTranslation';

const STORAGE_KEY = 'clevia_mvp_banner_dismissed';

export function MvpBanner() {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(STORAGE_KEY) === '1');

  if (dismissed) return null;

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setDismissed(true);
  };

  return (
    <div className="bg-amber-50 dark:bg-amber-950/40 border-b border-amber-200/60 dark:border-amber-800/40">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center gap-2 text-xs sm:text-sm">
        <Info className="w-3.5 h-3.5 text-amber-500 dark:text-amber-400 shrink-0" />
        <p className="text-amber-800 dark:text-amber-200 text-center min-w-0">
          {t('mvpBanner.message' as any)}
        </p>
        <button
          onClick={handleDismiss}
          className="p-0.5 rounded-md text-amber-600 dark:text-amber-400 hover:bg-amber-100 dark:hover:bg-amber-900/50 transition-colors shrink-0"
          aria-label="Close"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
